/**
 * Step 4: Generating content progress view
 */

import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export function GeneratingStep({ 
  generationProgress, 
  outputType,
  getProgressMessage 
}) {
  return (
    <motion.div
      key="step4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="text-center py-12"
      data-testid="generating-step"
    >
      <div className="w-20 h-20 rounded-full bg-viraly-orange/20 flex items-center justify-center mx-auto mb-6">
        <Loader2 className="w-10 h-10 text-viraly-orange animate-spin" />
      </div>
      <h2 className="font-heading text-2xl font-bold mb-2">Creating Your Content</h2>
      <p className="text-viraly-muted mb-6">{getProgressMessage()}</p>
      
      {/* Progress Bar */}
      <div className="max-w-md mx-auto">
        <div className="h-2 bg-white/10 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-viraly-gradient"
            initial={{ width: 0 }}
            animate={{ width: `${generationProgress}%` }}
            transition={{ duration: 0.5 }}
          />
        </div>
        <p className="text-sm text-viraly-muted mt-2">{generationProgress}% complete</p>
      </div>
      
      {outputType === "video" && (
        <div className="mt-8 p-4 rounded-xl bg-white/5 max-w-md mx-auto">
          <p className="text-sm text-viraly-muted">
            <span className="text-viraly-orange font-medium">Pro tip:</span> Video generation typically takes 2-3 minutes. 
            Your video will be saved automatically and available in your scheduled messages for you to approve.
          </p>
        </div>
      )}
    </motion.div>
  );
}
